import { useCallback, useEffect, useState } from "react";
import { InvoiceGroupService } from "../services/InvoiceGroupService";

export const useHookInvoiceGroup = () => {
    const [data, setData] = useState([]);
    const [meta, setMeta] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [params, setParams] = useState({
        search: "",
        nas_id: "",
        pop_id: "",
        odc_id: "",
        odp_id: "",
        page: 1,
        limit: 10,
    });

    const getData = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await InvoiceGroupService.get({params: params});

            const result = res?.data?.data ?? [];

            setData(Array.isArray(result) ? result : []);
            setMeta(res?.data?.meta);
        } catch (err) {
            console.error(err);
            setError(err?.response?.data || err);
        } finally {
            setLoading(false);
        }
    }, [params]);

    useEffect(() => {
        getData();
    }, [getData]);

    return {
        data,
        meta,
        loading,
        error,

        params, setParams,
        refreshData: getData,
    };
};